import { BaseModel } from './base';

export class BidType extends BaseModel {
  bidName: string;
  id: string;
  _id: string;
}
